"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IPerformerListListComponentTypeContext = exports.IItemRemovalExclusionContext = exports.IXmentServiceContext = exports.IUserContext = exports.ITranslationServiceContext = exports.IThemeContext = exports.IStreamPlayerFactoryContext = exports.IStatsdClientContext = exports.ISearchSkinConfigContext = exports.ISearchApiClientFactoryContext = exports.IRouterContext = exports.IRemoteAssetLoaderContext = exports.ILoggerContext = exports.ILinkComponentContext = exports.ILayoutContext = exports.IFavoritePerformersServiceContext = exports.IEventPublisherContext = exports.IDataUrlCacheContext = exports.IDataSourceContext = exports.IImageBucketContext = exports.IAutocompleteServiceContext = void 0;
/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
exports.IAutocompleteServiceContext = React.createContext(undefined);
exports.IImageBucketContext = React.createContext(undefined);
exports.IDataSourceContext = React.createContext(undefined);
exports.IDataUrlCacheContext = React.createContext(undefined);
exports.IEventPublisherContext = React.createContext(undefined);
exports.IFavoritePerformersServiceContext = React.createContext(undefined);
exports.ILayoutContext = React.createContext(undefined);
exports.ILinkComponentContext = React.createContext(undefined);
exports.ILoggerContext = React.createContext(undefined);
exports.IRemoteAssetLoaderContext = React.createContext(undefined);
exports.IRouterContext = React.createContext(undefined);
exports.ISearchApiClientFactoryContext = React.createContext(undefined);
exports.ISearchSkinConfigContext = React.createContext(undefined);
exports.IStatsdClientContext = React.createContext(undefined);
exports.IStreamPlayerFactoryContext = React.createContext(undefined);
exports.IThemeContext = React.createContext(undefined);
exports.ITranslationServiceContext = React.createContext(undefined);
exports.IUserContext = React.createContext(undefined);
exports.IXmentServiceContext = React.createContext(undefined);
exports.IItemRemovalExclusionContext = React.createContext(undefined);
exports.IPerformerListListComponentTypeContext = React.createContext(undefined);
//# sourceMappingURL=Contexts.js.map